import type { Example } from "../types";
import code from "./code.js" with { type: "text" };
import golden from "./golden.json";

export const walletDrainerProbe: Example = {
  id: "wallet-drainer-probe",
  title: "Wallet drainer probe",
  group: "incident",
  environment: "browser",
  mode: "script",
  summary: "Finds the injected wallet, hooks ethereum.request, and asks for accounts",
  explainer:
    "Runs with the Crypto user decoys, so `window.ethereum` is a MetaMask-style stand-in. The " +
    "probe, the hook on `ethereum.request` (a critical hooking finding), the " +
    "`eth_requestAccounts` call, and the attempted transfer are all recorded; the decoy refuses " +
    "to sign (code 4001). Switch the decoys to Bare page and the script finds no wallet.",
  code,
  context: { decoys: ["ethereum"] },
  expect: golden as Example["expect"],
};
